<div class="image-container hand" *ngFor="let img of images" (click)="service.displayImage(img)"
    [ngStyle]="{'display': icon ? 'inline' : 'block'}">
    <img [ngSrc]="img" *ngIf="!icon" />
    <cds-icon shape="image" *ngIf="icon"></cds-icon>
</div>
